import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface Session {
  id: number;
  title: string;
  date: string;
  time: string;
  mentor: string;
  status: "Upcoming" | "Completed";
}

interface SessionState {
  sessions: Session[];
  filters: {
    status: string;
    date: string;
    search: string;
  };
  modal: {
    isOpen: boolean;
    type: "add" | "edit" | null;
    sessionToEdit: Session | null;
  };
  setSessions: (sessions: Session[]) => void;
  setFilters: (filters: Partial<SessionState["filters"]>) => void;
  addSession: (session: Session) => void;
  updateSession: (updatedSession: Session) => void;
  deleteSession: (id: number) => void;
  openModal: (type: "add" | "edit", sessionToEdit: Session | null) => void;
  closeModal: () => void;
}


// Persisted Zustand store
export const useSessionStore = create<SessionState>()(
  persist(
    (set) => ({
      sessions: [],
      filters: {
        status: "all",
        date: "",
        search: "",
      },
      modal: {
        isOpen: false,
        type: null,
        sessionToEdit: null,
      },
      setSessions: (sessions) => set(() => ({ sessions })),
      setFilters: (filters) =>
        set((state) => ({
          filters: { ...state.filters, ...filters },
        })),
      addSession: (session) =>
        set((state) => ({
          sessions: [...state.sessions, session],
        })),
      updateSession: (updatedSession) =>
        set((state) => ({
          sessions: state.sessions.map((session) =>
            session.id === updatedSession.id ? updatedSession : session
          ),
        })),
      deleteSession: (id) =>
        set((state) => ({
          sessions: state.sessions.filter((session) => session.id !== id),
        })),
      openModal: (type, sessionToEdit = null) =>
        set(() => ({
          modal: { isOpen: true, type, sessionToEdit },
        })),
      closeModal: () =>
        set(() => ({
          modal: { isOpen: false, type: null, sessionToEdit: null },
        })),
    }),
    {
      name: "session-store", // Key for browser storage
    }
  )
);
